/*** IMPORTS FROM imports-loader ***/
var $ = require("jquery");
var jQuery = require("jquery");

var $ = require('../../modules/$');
require('../../modules/es6.object.get-own-property-descriptor');
module.exports = function getOwnPropertyDescriptor(it, key){
  return $.getDesc(it, key);
};



/*****************
 ** WEBPACK FOOTER
 ** ./~/core-js/library/fn/object/get-own-property-descriptor.js
 ** module id = 1316
 ** module chunks = 0
 **/